import * as Sentry from '@sentry/react';
import {
  normalizeSentryEnvironment,
  scrubSentryBreadcrumb,
  scrubSentryEvent,
} from './sentryScrubbing';

function parseSampleRate(value: unknown, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1 ? parsed : fallback;
}

export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  const environment = normalizeSentryEnvironment(
    process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT
  );
  const production = environment === 'production';

  Sentry.init({
    dsn,
    enabled: Boolean(dsn),
    environment,
    release: process.env.REACT_APP_SENTRY_RELEASE || 'lookbel-web@0.1.0',
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
      production ? 0.1 : 1.0
    ),
    beforeSend: (event) => scrubSentryEvent(event),
    beforeSendTransaction: (event) => scrubSentryEvent(event),
    beforeBreadcrumb: (breadcrumb) => scrubSentryBreadcrumb(breadcrumb),
  });
}
